import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

import { PersonalApiKey } from "../gql";

export const PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY = "personalApiKeysColumnsConfig";
export const PERSONAL_API_KEYS_FILTERS_ORDER_KEY = "personalApiKeysFiltersOrder";

export enum PERSONAL_API_KEYS_COLUMN_ID {
  NAME = "NAME",
  KEY_ID = "KEY_ID",
  EXPIRES_AT = "EXPIRES_AT",
  LAST_USED = "LAST_USED",
  ISSUES = "ISSUES",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const PERSONAL_API_KEYS_COLUMN_CONFIG: Record<PERSONAL_API_KEYS_COLUMN_ID, TableColumnMeta> =
  {
    [PERSONAL_API_KEYS_COLUMN_ID.NAME]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.NAME,
      title: "Name",
      minWidth: 150,
      defaultWidth: 280,
      maxWidth: MAX_CELL_WIDTH,
      resizable: true,
      allowsSorting: true,
      canHide: false,
      canMove: false,
      canPin: false,
    },
    [PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.KEY_ID,
      title: "Key ID",
      minWidth: 200,
      defaultWidth: 320,
      maxWidth: MAX_CELL_WIDTH,
      resizable: true,
      allowsSorting: true,
      canHide: false,
      canMove: false,
      canPin: false,
    },
    [PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT,
      title: "Expires at",
      minWidth: 120,
      defaultWidth: 160,
      maxWidth: 400,
      resizable: true,
      allowsSorting: true,
      canHide: false,
      canMove: false,
      canPin: false,
    },
    [PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.LAST_USED,
      title: "Last used",
      minWidth: 120,
      defaultWidth: 160,
      maxWidth: 400,
      resizable: true,
      allowsSorting: true,
      canHide: false,
      canMove: false,
      canPin: false,
    },
    [PERSONAL_API_KEYS_COLUMN_ID.ISSUES]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.ISSUES,
      title: "Issues",
      minWidth: 100,
      defaultWidth: 140,
      maxWidth: 400,
      resizable: true,
      allowsSorting: false,
      canHide: false,
      canMove: false,
      canPin: false,
    },
    [PERSONAL_API_KEYS_COLUMN_ID.DROPDOWN]: {
      id: PERSONAL_API_KEYS_COLUMN_ID.DROPDOWN,
      title: "API key actions",
      noHeader: true,
      minWidth: 60,
      defaultWidth: 60,
      maxWidth: 60,
      resizable: false,
      allowsSorting: false,
      canHide: false,
      canMove: false,
      canPin: false,
      configurable: false,
    },
  };

type PersonalApiKeysSortKey = keyof Pick<
  typeof PERSONAL_API_KEYS_COLUMN_ID,
  "NAME" | "KEY_ID" | "EXPIRES_AT" | "LAST_USED"
>;

export const PERSONAL_API_KEYS_SORT_CONFIG: Record<PersonalApiKeysSortKey, keyof PersonalApiKey> = {
  [PERSONAL_API_KEYS_COLUMN_ID.NAME]: "name",
  [PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: "id",
  [PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: "expiresAt",
  [PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: "lastUsedAt",
};

export const PERSONAL_API_KEYS_INITIAL_SORT = {
  field: PERSONAL_API_KEYS_SORT_CONFIG[PERSONAL_API_KEYS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
